module.exports = __webpack_public_path__ + "img/arrow_first.baf1814f.svg";